import shipmentsSaga from '~/sagas/shipments/shipments.saga';

export default shipmentsSaga;
